
import {
  IPSAddtitionalProcessingStep,
  IProcessingStep
} from '@/types/processingSteps'
import { Component, Mixins } from 'vue-property-decorator'
import ProcessingStepMixin from "@/components/processing_steps/ProcessingStepMixin.vue"
import ResultReportSummaryMixin from "@/components/processing_steps/result_report/mixins/ResultReportSummaryMixin.vue"

@Component
export default class ResultReportStepMixin extends Mixins(ProcessingStepMixin, ResultReportSummaryMixin) {
  steps: (IProcessingStep | IPSAddtitionalProcessingStep)[] = []
  additionalStepsAfterFirstStep = []
  projectCategoryAvailability = false

  firstStep: IProcessingStep = {
    key: "basic",
    title: this.$gettext("Basic information"),
    completed: false,
    required: true,
    active: true,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  secondStep: IProcessingStep = {
    key: "what_we_achieved",
    title: this.$gettext("What we achieved"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  thirdStep: IProcessingStep = {
    key: "finance",
    title: this.$gettext("Financial report"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  fourthStep: IProcessingStep = {
    key: "contact_persons",
    title: this.$gettext("Contact persons"),
    completed: false,
    required: true,
    active: false,
    buttons: {
      save: true,
      saveAndNext: true
    }
  }

  fifthStep: IProcessingStep = {
    key: "completition",
    title: this.$gettext("Release"),
    completed: false,
    required: false,
    active: true,
    buttons: {
      save: this.isSiteAdmin,
      saveAndNext: false
    }
  }

  setSteps (): void {
    this.steps = [
      this.firstStep,
      ...this.additionalStepsAfterFirstStep,
      this.secondStep,
      ...(this.project.organization.country !== 'DE' ? [this.thirdStep] : []),
      this.fourthStep,
      this.fifthStep

    ]
  }
}
